import React from "react";

// Components
import { Fulfillment } from "@secondcloset/types";

import { ExclamationCircleTwoTone } from "@ant-design/icons";
import { Space } from "antd";
import { ColumnsType } from "antd/es/table";
import moment from "moment";

import colors from "css/colors";

import { OrderIDTitle, OrderID, ShipmentTagTitle, ShipmentTags } from "./components";
import { Shipment } from "@secondcloset/fulfillment-utils";

type Order = Fulfillment.Order<"V1">;

export const getOrderBaseColumns = () => {
  const renderDefault = (text: string) => text || "-";

  const renderCreatedAt = (date: string) => moment(date).format("LL");

  const renderOrderStatus = (cancelled: boolean, { has_errors }: Order) => {
    const status = has_errors ? "Error" : cancelled ? "Cancelled" : "Active";
    const color = has_errors || cancelled ? colors.RED : colors.GREEN;
    return <div style={{ color: color }}>{status}</div>;
  };

  return [
    {
      title: <OrderIDTitle />,
      dataIndex: "order_id",
      key: "order_id",
      ellipsis: true,
      render(text, { status, id, has_errors }: Order) {
        return (
          <Space>
            <OrderID {...{ status, text, id }} />
            {has_errors && <ExclamationCircleTwoTone twoToneColor="red" />}
          </Space>
        );
      },
    },
    {
      title: "Order Status",
      dataIndex: "cancelled",
      key: "cancelled",
      render: renderOrderStatus,
    },
    {
      title: <ShipmentTagTitle />,
      dataIndex: "shipment_tags",
      key: "shipment_tags",
      render(tags: Order["shipment_tags"], { shipments }: Order) {
        return (
          <ShipmentTags tags={Shipment.hasInternalBooking(shipments || []) ? [...tags, "internal_booking"] : tags} />
        );
      },
    },
    {
      title: "External Order No.",
      dataIndex: "external_order_number",
      key: "external_order_number",
      render: renderDefault,
    },
    {
      title: "Platform",
      dataIndex: "platform",
      key: "platform",
      width: 100,
      render: renderDefault,
    },
    {
      title: "Date Created",
      dataIndex: "created_at",
      key: "created_at",
      sorter: true,
      render: renderCreatedAt,
    },
  ] as ColumnsType;
};
